/**
 * Customer Settings V2 — "Contacts" section: presence-only mount of
 * the legacy `CustomerContactsTab` for feature parity without
 * rebuilding its internals.
 *
 * Contains:
 * - ContactsSection (default export)
 */

import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { SettingsSection } from '@sophocles/views/settings/components';
import CustomerContactsTab from '@sophocles/views/settings/components/CustomerContactsTab';

import { staffOnlyChip } from './chips';

export default function ContactsSection({ customerId }) {
  const { t } = useTranslation();
  return (
    <SettingsSection
      id="settings-contacts"
      icon={<ContactPhoneIcon />}
      title={t('customerSettings.v2.contacts', 'Contacts')}
      description={t('customerSettings.contactsDescription', 'Customer contact information.')}
      chip={staffOnlyChip(t)}
    >
      <CustomerContactsTab customerId={customerId} />
    </SettingsSection>
  );
}
